import { flagApiIdentifier } from '../../../constants/evs/flagsmithApiKey';
import { FLAGSMITH_URL } from '../../../utils/config';
import { STORE_FLAGSMITH_DATA } from '../../action-contants';
import { handleError } from '../common-message/message-action';
import { makeApiCall } from '../common/common-action';

const storeFlagsmithData = (data) => {
  return {
    type: STORE_FLAGSMITH_DATA,
    data
  };
};

export const fetchFlagsFromFlagsmith = () => {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        url: `${FLAGSMITH_URL}`,
        method: 'get',
        headers: { 'x-environment-key': flagApiIdentifier },
        isFlagsmithApiCall: true
      });
      if (response?.status === 200 && response.data) {
        const features = response.data;
        const flags = {};

        features?.forEach((feature) => {
          flags[feature.feature?.name?.toLowerCase()?.replace(/ /g, '_')] = {
            id: feature.feature.id,
            enabled: feature.enabled,
            value: feature.feature_state_value
          };
        });
        dispatch(storeFlagsmithData(flags));
      }
    } catch (err) {
      //eslint-disable-next-line
      console.log('Error in fetching flagsmith values: ', err);
      dispatch(handleError(err));
    }
  };
};
